// po idee eto po templates same as app/setup/config/project-templates.js
// no tut est' nemnogo drugie params


import {ProjectSystemType} from "../../../../../../core/model2/project/types"

const project = {
    "id": "MfLWlW",
    "name": "Project",
    "img": "/app/static/templates/generic/project.svg",
    // "img": "/app/static/templates/project.jpg",
    "description": "Use project to organize work items with a common goal.",
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    setupDemoProject: false,
    demoFolderColor: 21
};

const taskList = {
    "id": "GAcEQx",
    "name": "Task list",
    "img": "/app/static/templates/generic/list.svg",
    // "img": "/app/static/templates/list.jpg",
    "description": "Track your todo’s and focus on moving tasks forward to completion.",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: false, //'generic',
    demoFolderColor: 21
};

const sprint = {
    "id": "CIV6ny",
    "name": "Sprint",
    "img": "/app/static/templates/generic/sprint.svg",
    // "img": "/app/static/templates/sprint.jpg",
    "description": "Create a group of tasks to organize sprint iteration",
    systemType: ProjectSystemType.SPRINT,
    copyToLocalTemplate: false,
    setupDemoProject: false,
    demoFolderColor: 21
};

const backlog = {
    "id": "FKWZ8T",
    "name": "Backlog",
    "img": "/app/static/templates/generic/backlog.svg",
    // "img": "/app/static/templates/backlog.jpg",
    "description": "List of tasks to be scheduled and completed in the future",
    copyToLocalTemplate: false,
    systemType: ProjectSystemType.BACKLOG,
    setupDemoProject: false,
    demoFolderColor: 21
};

const kanban = {
    "id": "hjXmWa",
    "name": "Kanban",
    "img": "/app/static/templates/generic/kanban.svg",
    // "img": "/app/static/templates/board.jpg",
    "description": "Use Kanban board to plan and execute your initiatives.",
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    setupDemoProject: false,
    demoFolderColor: 21
};

const waterfall = {
    "id": "CoC4hj",
    "name": "Waterfall Project",
    "img": "/app/static/templates/generic/waterfall.svg",
    // "img": "/app/static/templates/waterfall.jpg",
    "description": "Project structure built to align with waterfall methodology.",
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    setupDemoProject: false,
    demoFolderColor: 21
};

const scrumProject = {
    "id": "V5iomc",
    "name": "Scrum Project",
    "img": "/app/static/templates/generic/scrum.svg",
    // "img": "/app/static/templates/scrum.jpg", // https://image.shutterstock.com/image-vector/scrum-agile-methodology-software-development-260nw-256253887.jpg
    "description": "Scrum methodology based project.",
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    setupDemoProject: false,
    demoFolderColor: 21
};

const gantt = {
    "id": "9vs8YV",
    "name": "Gantt Project",
    "img": "/app/static/templates/generic/gantt.svg",
    // "img": "/app/static/templates/gantt.jpg",
    "description": "Gantt chart based project.",
    systemType: ProjectSystemType.PROJECT,
    copyToLocalTemplate: false,
    setupDemoProject: false,
    demoFolderColor: 21
};

const files = {
    "id": "aaaawq",
    "name": "Files & Documents",
    "img": "/app/static/templates/generic/files.svg",
    // "img": "/app/static/templates/files.jpg",
    "description": "Documents and files management",
    systemType: ProjectSystemType.FOLDER,
    copyToLocalTemplate: false,
    setupDemoProject: false,
    demoFolderColor: 21
};

export default {
    id: 'generic',
    name: "Generic",
    items: [
        project,
        taskList,
        kanban,
        sprint,
        backlog,
        scrumProject,
        gantt,
        waterfall,
        files,
    ]
};